import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Scrollbar, Keyboard, Mousewheel } from "swiper";
import "swiper/css";

SwiperCore.use([Scrollbar, Keyboard, Mousewheel]);

export const Slide = SwiperSlide;

const Slideshow = ({ children, extraConfig }) => {
  return (
    <Swiper
        spaceBetween={32}
        slidesPerView={3}
        centeredSlides={false}
        grabCursor={true}
        scrollbar={{ draggable: true }}
        simulateTouch={true}
        touchEventsTarget='container'
        touchRatio={1}
        touchAngle={45}
        threshold={5}
        mousewheel={{forceToAxis: true}}
        modules={[Scrollbar, Keyboard, Mousewheel]}
        breakpoints={{
            300: {
                slidesPerView: 1.2,
                centeredSlides: true,
                spaceBetween: 14,
            },
            768: {
                slidesPerView: 2,
                centeredSlides: false,
            },
            1024: {
                slidesPerView: 3,
                centeredSlides: false,
            },
        }
      }
    {...extraConfig}
    >
        {children}
    </Swiper>
  )
}

export default Slideshow